
import { labelTypeOptions } from '@/helpers/labelTypes'
import api from '@/store/api'

export default {
  data() {
    return { label_name: '', label_type: '' }
  },
  computed: {
    labelTypeOptions() {
      return labelTypeOptions
    }
  },
  methods: {
    handleKeydown(event) {
      // 'Enter' outside textarea
      if (event.keyCode === 13 && event.target.localName !== 'textarea') event.preventDefault()
    },
    handleSubmit() {
      api
        .call('POST', 'labels', {
          label: this.$data
        })
        .then(() => {
          this.$router.push('/store/labels/')
        })
    }
  }
}
